import React, { useState } from "react";
import "./index.scss";
import { InputLabel } from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const Password = ({
  value,
  onChange,
  placeholder,
  label,
  name,
  showHidePasswordIcon = true,
  isError,
  onBlur
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="password-input-container">
      <InputLabel className="label mb-2 fw-bold" htmlFor={name}>
        {label}
      </InputLabel>
      <div
        className={`password-feild d-flex align-items-center px-3 py-2 ${
          isError ? "error-input" : ""
        }`}
      >
        <input
          className="w-100"
          name={name}
          type={showPassword || !showHidePasswordIcon ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          id={name}
          onBlur={onBlur}
        />
        <>
          {!showPassword ? (
            <VisibilityOffOutlinedIcon
              onClick={() => setShowPassword(!showPassword)}
            />
          ) : (
            <VisibilityOutlinedIcon
              onClick={() => setShowPassword(!showPassword)}
            />
          )}
        </>
      </div>
    </div>
  );
};

export default Password;
